import { FC } from 'react'
import Box from '@mui/material/Box'
import { DataLoad, RapidRHColumnsDataGrid } from 'src/components'
import { useWagnerProbeListRequest } from 'src/hooks/api'
import { useQueryParams } from 'src/hooks/ui'
import { WagnerProbeList } from 'src/pages/WagnerProbe.list'

interface Props {
  contractorId: number;
}

const defaultPerPage = 50
const defaultPage = 1
const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`,
}
const rapidRhColumns = [
  RapidRHColumnsDataGrid.ProbeId,
  RapidRHColumnsDataGrid.IsOnline,
  RapidRHColumnsDataGrid.ReadingTime,
  RapidRHColumnsDataGrid.Label,
  RapidRHColumnsDataGrid.ReaderId,
  RapidRHColumnsDataGrid.VerizonGAT,
  RapidRHColumnsDataGrid.Project,
  RapidRHColumnsDataGrid.ProjectSection,
  RapidRHColumnsDataGrid.LastDeviceType,
  RapidRHColumnsDataGrid.LastSignalStrength,
  RapidRHColumnsDataGrid.LastBatteryLevel,
  RapidRHColumnsDataGrid.ReceivedFromDataGrabber,
  RapidRHColumnsDataGrid.ReceivedFromMiniGrabber,
  RapidRHColumnsDataGrid.ReceivedFromTotalReader,
  RapidRHColumnsDataGrid.ReceivedFromRepeater,
  RapidRHColumnsDataGrid.ReceivedViaPhone,
  RapidRHColumnsDataGrid.ReceivedViaGAT,
  RapidRHColumnsDataGrid.CreatedAt,
]

export const ContractorWagnerProbeList: FC<Props> = ({
  contractorId,
}) => {
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)
  const { isInitialLoading, isError, error, data } = useWagnerProbeListRequest({
    params: {
      contractorId,
      ...queryParams,
    },
  })
  const exportedFileName = `${document.title}_rapid_rh_probes`

  return (
    <DataLoad isLoading={false} isError={isError} errorMessage={error?.message}>
      <Box height="500px">
        <WagnerProbeList
          wagnerProbeCount={data?.count || 0}
          wagnerProbes={data?.rows || []}
          isLoadingWagnerProbes={isInitialLoading}
          setQueryParams={setQueryParams}
          queryParams={queryParams}
          exportedFileName={exportedFileName}
          tableColumns={rapidRhColumns}
        />
      </Box>
    </DataLoad>
  )
}
